// extracted by mini-css-extract-plugin
module.exports = {"linkTrigger":"christmasSchedule_linkTrigger__1h3p4","cutoffTable":"christmasSchedule_cutoffTable__16r2l"};